<script lang="ts" setup>
import { type PropType } from 'vue'
import { isFilterMatch } from '@/utils/filter'

import GIPointRow from '@/components/gi-drawer/GIPointRow.vue'
import GIPointBaseTable from '@/components/base/GIPointBaseTable.vue'

import { useGiPointStore } from '@/stores/giPoints'
import type { GiDataUploadCollectionType } from '@/stores/type/giPoint.type'
import { storeToRefs } from 'pinia'

const props = defineProps({
  item: {
    type: Object as PropType<GiDataUploadCollectionType>,
    required: true
  },
  selectedFilter: {
    type: String,
    required: false
  },
  searchQuery: {
    type: String,
    required: false
  },
  isSelectedTable: {
    type: Boolean,
    required: false
  },
  showSelect: { type: Boolean, default: false }
})

const giPointsStore = useGiPointStore()

const { items: giPoints } = storeToRefs(giPointsStore)

const filteredGIPointsByType = (giPointCollection: GiDataUploadCollectionType) => {
  const selectedType = props.selectedFilter
  const searchTerm = props.searchQuery?.toLowerCase()

  return giPoints.value.filter((giPoint) => {
    const isInCollection = giPoint.properties?.gi_data_upload_collection === giPointCollection.id
    if (!isInCollection) {
      return false
    }
    const locationId = giPoint.properties?.location_id?.toLowerCase()
    const giType = giPoint.properties?.gi_type
    const searchMatch = searchTerm && searchTerm !== '' ? locationId.includes(searchTerm) : true
    const filterMatch = selectedType ? isFilterMatch(giType, selectedType) : true
    return searchMatch && filterMatch
  })
}
</script>

<template>
  <GIPointBaseTable
    :items="filteredGIPointsByType(item)"
    :show-select="props.showSelect"
    :is-selected-table="isSelectedTable"
  >
    <template v-slot:item="{ item }: { item: any }">
      <GIPointRow
        :item="item"
        :store="giPointsStore"
        :show-select="showSelect"
        @click="giPointsStore.setCurrentItem(item)"
      />
    </template>
  </GIPointBaseTable>
</template>
